define('home/templates/postContent',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "comment-message-hidden";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<div class=\"comment-message expanded "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isHidden : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\"\ndata-role=\"message\" dir=\"auto\">\n"
    + ((stack1 = container.lambda((depth0 != null ? depth0.message : depth0), depth0)) != null ? stack1 : "")
    + "\n<div><ul class=\"post-media\" data-role=\"post-media-list\"></ul></div>\n</div>\n<a  href=\"#\" class=\"curtain-truncate hidden\" title=\""
    + alias2(helpers.gettext.call(alias1,"see more",{"name":"gettext","hash":{},"data":data}))
    + "\"\ndata-action=\"expand\"\ndata-target=\".comment-message\">"
    + alias2(helpers.gettext.call(alias1,"see more",{"name":"gettext","hash":{},"data":data}))
    + "</a>\n";
},"useData":true})

});
